import React, {useState} from 'react';

export default function CsfBrokerPagination(props) {

  let firstDisplayedPageNumber = props.activePage - 4;
  if (firstDisplayedPageNumber <= 0) {
    firstDisplayedPageNumber = 1;
  }

  let lastDisplayedPageNumber = firstDisplayedPageNumber + 8;
  if (lastDisplayedPageNumber > props.totalPages) {
    lastDisplayedPageNumber = props.totalPages;
  }

  let lastDisplayedPageNumberArray = Array.apply(null, {length: lastDisplayedPageNumber}).map(Number.call, Number);

  let paginationSizes = {
    25: 25, 50: 50, 75: 75, 100: 100, 'all': window.Drupal.t('broker.pagination.all_pages')
  };

  return (<div className="broker-pagination-wrap d-flex justify-content-center align-items-center w-100 py-3 width-exempt">
      <nav className="pager broker-pager" role="navigation" aria-labelledby="pagination-heading">
        <h4 id="pagination-heading" className="visually-hidden">{window.Drupal.t('pagination.title')}</h4>
        <ul className="pager__items js-pager__items pagination mb-0">
          {props.activePage >= 2 && (<li className="pager__before">
            <ul>
              <li className="pager__item pager__item--first page-item">
                <a href="#"
                   data-page="1"
                   title={window.Drupal.t('pagination.firstPageTitle')} className="page-link"
                   onClick={props.handlePageChangeChange}
                >
                  <span className="visually-hidden">{window.Drupal.t('pagination.firstPageTitleHidden')}</span>
                  <span aria-hidden="true">{window.Drupal.t('pagination.firstPage')}</span>
                </a>
              </li>
              <li className="pager__item pager__item--previous page-item">
                <a href="#"
                   data-page={parseInt(props.activePage) - 1}
                   title={window.Drupal.t('pagination.previousPageTitle')} rel="prev" className="page-link"
                   onClick={props.handlePageChangeChange}
                >
                  <span className="visually-hidden">{window.Drupal.t('pagination.previousPageTitleHidden')}</span>
                  <span aria-hidden="true">{window.Drupal.t('pagination.previousPage')}</span>
                </a>
              </li>
            </ul>
          </li>)}

          {lastDisplayedPageNumberArray.map((item, index) => (index + 1 >= firstDisplayedPageNumber && (
            <li key={index + 1} className="pager__numbers">
              <ul>
                {index + 1 == props.activePage ? (
                  <li className="pager__item is-active active page-item page-item--number">
                    <a href="#"
                       data-page={index + 1}
                       title={window.Drupal.t('pagination.currentPageTitle')}
                       className="paragraph--columns-width is-active active page-link"
                       onClick={props.handlePageChangeChange}
                    >
                          <span
                            className="visually-hidden">{window.Drupal.t('pagination.currentPageTitle')}</span>{index + 1}
                    </a>
                  </li>) : (<li className="pager__item page-item page-item--number">
                  <a href="#"
                     data-page={index + 1}
                     title={window.Drupal.t('pagination.pageTitle') + index + 1}
                     className="paragraph--columns-width page-link"
                     onClick={props.handlePageChangeChange}
                  >
                    <span className="visually-hidden">{window.Drupal.t('pagination.page')}</span>{index + 1}
                  </a>
                </li>)}
              </ul>
            </li>)))}


          {props.totalPages > 9 && (<li className="pager__numbers">
            <ul>
              <li className="pager__item pager__item--ellipsis page-item" role="presentation">…</li>
            </ul>
          </li>)}

          {props.totalPages > props.activePage && (<li className="pager__after">
            <ul>
              <li className="pager__item pager__item--next page-item">
                <a
                  href="#"
                  data-page={parseInt(props.activePage) + 1}
                  title={window.Drupal.t('pagination.nextPageTitle')}
                  rel="next"
                  className="page-link"
                  onClick={props.handlePageChangeChange}
                >
                <span className="visually-hidden">
                  {window.Drupal.t('pagination.nextPageTitleHidden')}
                </span>
                  <span aria-hidden="true">
                  {window.Drupal.t('pagination.nextPage')}
                </span>
                </a>
              </li>
              <li className="pager__item pager__item--last page-item">
                <a
                  href="#"
                  data-page={props.totalPages}
                  title={window.Drupal.t('pagination.lastPageTitle')}
                  className="page-link"
                  onClick={props.handlePageChangeChange}
                >
                <span className="visually-hidden">
                  {window.Drupal.t('pagination.lastPageTitleHidden')}
                </span>
                  <span aria-hidden="true">
                  {window.Drupal.t('pagination.lastPage')}
                </span>
                </a>
              </li>
            </ul>
          </li>)}
        </ul>

      </nav>

      {paginationSizes && props.pageSize && (<div className="broker-pagination-size d-flex align-items-center">
        <label className="m-0" htmlFor="PaginationPageSize">{window.Drupal.t('broker.pagination.label')}</label>
        <select id="PaginationPageSize" className="w-auto" name="pagesize" onChange={props.handlePageSizeChange} value={props.pageSize}>
          {Object.entries(paginationSizes).map(([key, value]) => (<option
            key={key}
            value={key}
          >
            {value}
          </option>))}
        </select>
      </div>)}

      {props.searchTotal > 9 && (<div className="broker-pagination-total">
        {window.Drupal.t('broker.pagination.total.label')}
        {props.searchTotal}
      </div>)}

    </div>

  );
}
